<script setup lang="ts">
useHead({
  title: "ページが見つかりませんでした",
});
</script>

<template>
  <TemplateNotFound />
</template>
